import React from "react";
import ArticleCard from "src/components/common/ArticleCard/ArticleCard";
import { Grid } from "@mui/material";
import { GridSize } from "@mui/material/Grid/Grid";
import { SpecialArticleItemSchema } from "src/models/articles/getSpecialArticle";

interface ArticleCardContainerProps {
  spacing: number;
  gridLg?: GridSize;
  articles: SpecialArticleItemSchema[];
  isLoading?: boolean;
}

const ArticleCardContainer: React.FC<ArticleCardContainerProps> = ({
  spacing,
  gridLg,
  articles,
  isLoading,
}) => {
  return (
    <Grid
      sx={{
        filter: isLoading ? "opacity(25%)" : "",
        paddingX: { xs: 1.5, lg: 0 },
      }}
      container
      spacing={spacing}
      mt={2}
    >
      {articles?.map((article, index) => (
        <ArticleCard
          href={article.slug}
          key={index}
          title={article.name}
          author={article.author}
          createDate={article.date}
          gridLg={gridLg}
          date={article.date}
        />
      ))}
    </Grid>
  );
};

export default ArticleCardContainer;
